import { render, staticRenderFns } from "./RankScore.vue?vue&type=template&id=48bb149b&"
import script from "./RankScore.vue?vue&type=script&lang=js&"
export * from "./RankScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports